import { render, staticRenderFns } from "./MyServicesSitecore.vue?vue&type=template&id=3b137ffb"
import script from "./MyServicesSitecore.vue?vue&type=script&lang=js"
export * from "./MyServicesSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports